module.exports = __webpack_public_path__ + "img/France_2_2018.876b4bd0.svg";